export const SET_NAME = 'SET_NAME'
export const SET_PHONE = 'SET_PHONE'
export const SET_COUNTRY = 'SET_CONTRY'
export const SET_USER_HAS_BEEN_CREATED = 'SET_USER_HAS_BEEN_CREATED'
